const Predracun = () => import("@views/app/pro-forma-payment/pro-forma-payment.vue");

export const predracunRoutes = [
    {
        name: "placilo_predracuna",
        path: "placilo",
        redirect: {name: "predracun"},
        children: [
            {
                component: Predracun,
                name: "predracun",
                path: "predracun"
            },
        ]
    }
];